import calculateReferenceLine from "./calculateReferenceLine.js";
import drawLine2 from "../../../draw/drawLine2";
import triggerEvent from "core/customEvent/triggerEvent";
import draw from "../../../draw/draw";
import { getEnabledElement } from "component/toolManager/enabledElements.js";
import math from "core/math";
/**
 * Renders the active reference line.
 *
 * @export @public @method
 * @name renderActiveReferenceLine
 * @param  {Object} context        The canvas context.
 * @param  {Object} targetElement      The data associated with the event.
 * @param  {Object} targetImagePlane    The element on which to render the reference line.
 * @param  {Object} referenceImagePlane
 * @param  {Object} [options={}]
 */
export default function (
  context,
  targetElement,
  targetImagePlane,
  referenceImagePlane,
  options = {}
) {
  const drawColor = options.drawColor || "#00ff00";
  // Target
  const tRowCosines = math.vector.convertToVector3(targetImagePlane.rowCosines);
  const tColCosines = math.vector.convertToVector3(
    targetImagePlane.columnCosines
  );

  // Reference
  const rRowCosines = math.vector.convertToVector3(
    referenceImagePlane.rowCosines
  );
  const rColCosines = math.vector.convertToVector3(
    referenceImagePlane.columnCosines
  );

  // The image plane normals must be > 30 degrees apart
  const targetNormal = tRowCosines.clone().cross(tColCosines);
  const referenceNormal = rRowCosines.clone().cross(rColCosines);
  let angleInRadians = targetNormal.angleTo(referenceNormal);

  angleInRadians = Math.abs(angleInRadians);
  if (angleInRadians < 0.5) {
    const angleInDegrees = angleInRadians * (180 / Math.PI);
    console.warn(`${angleInDegrees} angle is to small for reference lines.`);

    return;
  }

  const referenceLine = calculateReferenceLine(
    targetImagePlane,
    referenceImagePlane
  );

  if (!referenceLine) {
    return;
  }

  //const color = options.color || toolColors.getActiveColor();
  const color = drawColor;

  // Draw the referenceLines
  //context.setTransform(1, 0, 0, 1, 0, 0);
  let eventDataElementStub = getEnabledElement(targetElement);
  eventDataElementStub.needsRedraw = true;
  draw(context, (context) => {
    let eventDataElementStub = getEnabledElement(targetElement);
    eventDataElementStub.needsRedraw = true;
    triggerEvent(targetElement, "setState", []);
    referenceLine.start = math.coordinate.pixelToCanvas(
      targetElement,
      referenceLine.start
    );
    referenceLine.end = math.coordinate.pixelToCanvas(
      targetElement,
      referenceLine.end
    );
    drawLine2(context, targetElement, referenceLine.start, referenceLine.end, {
      color,
      lineWidth: 2,
    });
  });

  return referenceLine;
}
